import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { useUserStore } from "../hooks";
import ConfirmDialog from "@/components/common/ConfirmDialog";

const UnlockUserDialog = observer(({ user, onClose }) => {
  const { t } = useTran();
  const { unlockingUserId, unlockUser, loadUsers } = useUserStore();
  const loading = unlockingUserId === user?.id;

  const handleConfirm = async () => {
    if (!user?.id) return { success: false };
    const result = await unlockUser(user.id);
    if (result) {
      onClose?.();
      await loadUsers();
    }
    return result;
  };

  return (
    <ConfirmDialog
      open={Boolean(user)}
      onOpenChange={(openState) => {
        if (!openState) {
          onClose?.();
        }
      }}
      title={t("Unlock user")}
      description={t(
        "Are you sure you want to unlock this user’s account? This action will remove the current selected user lock immediately.",
      )}
      confirmLabel={t("Unlock")}
      cancelLabel={t("Cancel")}
      onConfirm={handleConfirm}
      loading={loading}
    />
  );
});

export default UnlockUserDialog;
